import { render } from "./CountrySelect.vue?vue&type=template&id=5f5a577e"
import script from "./CountrySelect.vue?vue&type=script&lang=js"
export * from "./CountrySelect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__